<div class="main">
  <div class="loading-shade" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
  </div>
  <div class="general-data">
    <table>
      <thead>
        <tr>
          <th>Tipo de instalación</th>
          <th>Diámetro Externo [pulg]</th>
          <th>Fecha de Instalación</th>
          <th>MD Base [m]</th>
          <th>
            <mat-slide-toggle [checked]="confirmFacilities" [disabled]="readOnlyContent"
                (change)="toggleConfirmAllFacilities($event); onSectionTouched('productionColumn')">
              <span *ngIf="!confirmFacilities">No </span>Hay Instalaciones
            </mat-slide-toggle>
            <span class="confirmar" *ngIf="confirmFacilities && !atLeastOneConfirmed">*Confirmar al menos una instalación</span>
          </th>
        </tr>
      </thead>
      <tbody *ngIf="productionColumnHeaders.length">
        <tr *ngFor="let header of productionColumnHeaders; index as i">
          <td>{{header.assemblyName}}</td>
          <td>{{header.assemblySize}}</td>
          <td>{{header.installDate | date: 'dd/MM/yyyy'}}</td>
          <td>{{header.mdLanded}}</td>
          <td>
            <mat-slide-toggle [disabled]="readOnlyContent || !confirmFacilities"
                [checked]="header.confirmed" (change)="toggleConfirmFacilities(i); onSectionTouched('productionColumn')">
              <span *ngIf="!header.confirmed">No </span>Confirmado
            </mat-slide-toggle>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="no-data" *ngIf="!isLoading && !productionColumnHeaders.length">
    <h3>No se encontraron datos</h3>
    <p>De existir datos en el sistema de<br>origen, podrás visualizarlos acá</p>
  </div>

  <div class="no-data" *ngIf="!isLoading && productionColumnHeaders.length && !displayFacilities">
    <h3>No hay instalaciones confirmadas aún</h3>
    <p>De confirmar instalaciones podrás visualizar acá sus componentes de Instalación de Fondo</p>
  </div>

  <div class="detail-container">
    <table mat-table *ngIf="!isLoading && displayFacilities"
        [dataSource]="productionColumnDetailFiltered" class="production-column-table handover-data-table">
      <ng-container matColumnDef="assemblyName" sticky>
          <mat-header-cell *matHeaderCellDef> Tipo de<br>Instalación </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index"> {{facility.assemblyName}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="component" sticky>
          <mat-header-cell *matHeaderCellDef> Descripción </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index">
              <ng-container>{{facility.component}}</ng-container>
          </mat-cell>
      </ng-container>
      <ng-container matColumnDef="size" sticky>
          <mat-header-cell *matHeaderCellDef> Diámetro<br>Externo [pulg] </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index">
              <ng-container>{{facility.size}}</ng-container>
          </mat-cell>
      </ng-container>
      <ng-container matColumnDef="joints">
          <mat-header-cell *matHeaderCellDef> Juntas<br>[núm] </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index">
            <ng-container>{{facility.joints}}</ng-container>
          </mat-cell>
      </ng-container>
      <ng-container matColumnDef="length">
          <mat-header-cell *matHeaderCellDef> Longitud<br>[m] </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index">
            <ng-container>{{facility.length}}</ng-container>
          </mat-cell>
      </ng-container>
      <ng-container matColumnDef="mdTop">
          <mat-header-cell *matHeaderCellDef> MD Tope<br>[m] </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index">
            <ng-container>{{facility.mdTop}}</ng-container>
          </mat-cell>
      </ng-container>
      <ng-container matColumnDef="mdBase">
          <mat-header-cell *matHeaderCellDef> MD Base<br>[m] </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index">
            <ng-container>{{facility.mdBase}}</ng-container>
          </mat-cell>
      </ng-container>
      <ng-container matColumnDef="weight">
          <mat-header-cell *matHeaderCellDef> Peso<br>[lib/pie] </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index">
            <ng-container>{{facility.weight}}</ng-container>
          </mat-cell>
      </ng-container>
      <ng-container matColumnDef="grade">
          <mat-header-cell *matHeaderCellDef> Grado </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index">
            <ng-container>{{facility.grade}}</ng-container>
          </mat-cell>
      </ng-container>
      <ng-container matColumnDef="threads">
          <mat-header-cell *matHeaderCellDef> Conexión </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index">
            <ng-container>{{facility.threads}}</ng-container>
          </mat-cell>
      </ng-container>
      <ng-container matColumnDef="condition">
          <mat-header-cell *matHeaderCellDef> Condición </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index">
            <ng-container>{{facility.condition}}</ng-container>
          </mat-cell>
      </ng-container>
      <ng-container matColumnDef="manufacturer">
          <mat-header-cell *matHeaderCellDef> Fabricante </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index">
            <ng-container>{{facility.manufacturer}}</ng-container>
          </mat-cell>
      </ng-container>
      <ng-container matColumnDef="statusInstallDate">
          <mat-header-cell *matHeaderCellDef> Fecha<br>Instalación </mat-header-cell>
          <mat-cell *matCellDef="let facility; let i = index">
            <ng-container>{{facility.statusInstallDate | date: 'dd/MM/yyyy'}}</ng-container>
          </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions" stickyEnd>
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let facility; let i = index" [ngClass]="'mat-column-save'">
          <button mat-mini-fab (click)="openComments(productionColumnDetailFiltered[i], i, $event, readOnlyContent);" class="comment-ho-icon" name="openComments">
            <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
            <div class="circle-comments" *ngIf="productionColumnDetailFiltered[i].comments"></div>
            <span class = "comment">Comentar</span>
          </button>
          <button mat-mini-fab (click)="save(productionColumnDetailFiltered[i], i);" class="save-ho-icon" [disabled]="isDisabled[i]" name="save">
            <mat-icon class="material-icons-outlined">save</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-header-row *matHeaderRowDef="displayedColumns" [ngClass]="{'sticky-header': true, visible: displayStickyHeader}"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </table>
  </div>
  <!-- File Attachment -->
  <div class="handover-files">
    <div class="top">
        <h2>Carta de Prueba de Tubing y/o Carta de Bombeo Mecánico</h2>
        <div>
            <div *ngIf="productionColumnAttachment == null">
                0{{ "/" + fileLimit + " Archivos" }}
              </div>
              <div *ngIf="productionColumnAttachment != null">
                {{ productionColumnAttachment?.length + "/" + fileLimit + " Archivos" }}
              </div>
        </div>
        <ng-container *ngIf="productionColumnAttachment?.length < fileLimit">
            <input
              type="file"
              class="file-input"
              accept=".xls, .xlsx, .pdf, .jpg, .jpeg, .png, .gif"
              (change)="onFileSelected($event)"
              #fileUpload
              style="display: none"
            />
            <div class="attach" title="Documento">
              <button
                mat-button
                class = "upload-button"
                (click)="fileUpload.click()"
                [disabled]="readOnlyContent">
                <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar Archivo
              </button><br/>
              <span>Archivos Excel, PDF e Imágenes</span>
            </div>
        </ng-container>
    </div>

    <div class="grid-attachment">
        <div class = "attachment" *ngFor="let f of productionColumnAttachment">
            <a
                class="attachment-link"
                href="{{dhoApiUrl}}/{{ f?.file_path }}"
                download="{{ f?.file_original_name }}"
                target="_blank"
            >
                {{ f?.file_original_name }}
            </a>
            <!-- Boton borrar-->
            <button
                *ngIf="!readOnlyContent"
                mat-button
                class="delete-button"
                (click)="deletProductionColumnAttachment(f.file_id)"
                [disabled]="readOnlyContent"
            >
                <mat-icon class="material-icons-outlined">delete</mat-icon>
            </button>
        </div>
    </div>

</div>
</div>
